import React, { Component } from 'react';
import {
    Input,
    PageHeader,
    Select,
    Form,
    InputNumber,
    DatePicker,
    Switch,
    Upload,
    Button,
    Skeleton
} from 'antd';
// import { moveToPage } from "../../navigation/navigationService";
import { connect } from "react-redux";
// import moment from 'moment';
import { getCommissionForm, saveNewAsDraft } from '../../../services/api';
import { TYPES_OF_FORMS } from '../../../constants';
import { goBack } from 'connected-react-router';
import DynamicFormGenerator from '../../../components/DynamicFormGenerator';


class CommissionFormPage extends Component {

    state = {

    }

    componentDidMount = async () => {

        const form = await getCommissionForm()

        console.log(form)

        this.setState({ formData: form })
    }

    render() {

        return (

            this.state.formData ? (
                <DynamicFormGenerator
                    formData={this.state.formData}
                    title="Commission Requisition Form"
                    onSaveAsDraft={values => {
                        console.log('onsaveNewAsDraft', values)

                        /**Insert api here */
                        this.props.dispatch(goBack())
                    }}
                />
            ) :
                (
                    <div>
                        <h1>Loading...</h1>
                        <Skeleton active />
                    </div>
                )
        )
    }
}

const mapStateToProps = (state) => ({
    // for future if needed
})

export default connect(mapStateToProps)(CommissionFormPage);